import { Empresa } from './empresa';
import { Serializable } from './commom/serializable';

export class Pix implements Serializable<Pix> {
    public Id: number;    
    public Empresa: Empresa;
    public IdUsuario: number;  
    public PrimeiraCartela: string; 
    public SegundaCartela: string; 
    public CodRepresentante: number;
    public ImgFrente: string;      
    public ImgVerso: string;
    public VlrPix: number; 
    public Obs: string; 
    public ChavePix: string; 
    public TipoChavePix: string; 
    public NomeBanco: string;
    


    deserialize(input: Object): Pix {
        Object.assign(this, input);

        return this;
    }
}


// WEBPACK FOOTER //
// ./src/entities/pix.ts